<template v-if="globaljs.acc_type !== 'hospital' || globaljs.mb_staff !== 'Worker'">
	<include-header />

	<section id="set_lab2">
		<div id="setting_page2">
			<div class="content">
				<div class="contIn">
					<div class="sub_cont">
						<div class="boardTit">보철물 설정</div>
						<div class="sub_contBox">
							<form ref="form_prosthesis_update" id="form_prosthesis_update" :action="`${SERVER_URL}/api/app/prosthesis`" @submit.prevent="form_prosthesis_update_submit()" method="post" autocomplete="off">
								<input type="hidden" name="mode" value="update">
								<input type="hidden" name="deleted_id" value="">
								<input type="hidden" name="changed_id" value="">
								<input type="hidden" name="before_values" value="">
								<input type="hidden" name="after_values" value="">

								<div class="set_tabWrap">
									<div class="set_tabTit">
										<ul class="set_tab">
											<li class="active">
												<router-link to="/manage_prosthesis">기본 설정</router-link>
											</li>
											<li @click="step2js.prosthesisSelectPopup('/popup_prosthesis_select')">치과별 설정</li>
										</ul>
									</div>
									<button type="button" class="printBtn" @click="step2js.prosthesisPrintPopup('/popup_prosthesis_print')">출력</button>
								</div>

								<div class="subTitWrap">
									<div class="subTit">[보철물 목록]</div>
									<ul class="subBtn">
										<li><button type="button" class="setting_addBtn" @click.prevent="prosthesis_list_add()">추가</button></li>
										<li><button type="button" class="setting_okBtn" @click.prevent="form_prosthesis_update_submit()">저장</button></li>
									</ul>
								</div>

								<div class="align_right">
									<table>
										<tbody id="prosthesis_list">
											<tr>
												<th class="cols1">번호</th>
												<th class="cols2">분류</th>
												<th class="cols3">상세</th>
												<th class="cols4">단가</th>
												<th class="cols5">취급여부</th>
											</tr>
											<tr v-if="items.length > 0" v-for="(item, index) in items" :key="index">
												<td v-if="item.cant_del === 1" class="cols1">{{ index + 1 }}</td>
												<td v-else class="cols1">
													<button type="button" class="del_item" style="cursor:pointer; color:#ff0000;" :data-id="item.id" @click="prosthesis_list_del(index, item.id)">X</button>
												</td>
												<td class="cols2">
													<input type="hidden" name="cant_del[]" :value="item.cant_del">
													<input type="text" name="options[]" v-model="item.options" required="" :readonly="item.cant_del === 1" :class="item.cant_del === 1 ? 'readonly' : ''">
												</td>
												<td class="cols3"><input type="text" name="detail[]" v-model="item.detail" :readonly="item.cant_del === 1" :class="item.cant_del === 1 ? 'readonly' : ''"></td>
												<td class="cols4">
													<input type="text" data-type="number" name="price[]" v-model="item.price" required="" class="form-control" maxlength="8" @input="(event) => handleMaxLengthCheck(event, item)" @blur="(event) => handleValueCheck(event, item)">
												</td>
												<td class="cols5">
													<label><input type="checkbox" :name="`hide[${index}]`" v-model="item.hide" true-value="0" false-value="1" style="display: none;">
														<div class="eyes" :class="{ 'active': item.hide === 0 }"></div>
													</label>
												</td>
											</tr>
											<tr v-else>
												<td colspan="5">데이터가 없습니다.</td>
											</tr>
										</tbody>
									</table>
									<div class="plus_list" @click="prosthesis_list_add"><span class="plus_icon"></span>추가</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<include-footer />
</template>

<script>
import header from '../components/layout/header.vue';
import footer from '../components/layout/footer.vue';

export default {
	name: 'App',
	components: {
		'include-header': header,
		'include-footer': footer
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';
import * as step2js from '@/components/utils/setting_step2';

const route = useRoute();
const router = useRouter();

if(globaljs.acc_type === 'hospital' || globaljs.mb_staff === 'Worker') { commonjs.authSwal(); }

let submitingFlag = false; // 플래그 변수
const withSubmitFlag = async (asyncFunc) => {
	if (submitingFlag) return; // 요청 중복 방지
		submitingFlag = true; // 요청 시작 시 플래그 설정
	try {
		await asyncFunc(); // 비동기 함수 실행
	} finally {
		submitingFlag = false; // 요청이 끝나면 플래그 해제
	}
};

const items = ref([]);
let beforeData = [];
const list_num = ref(0);

// 이벤트 핸들러 함수 정의
function handleMaxLengthCheck(event, item) {
	maxLengthCheck(event, item); // `item`이 `dataObjectRef`로 전달됨
}

function handleValueCheck(event, item) {
	valueCheck(event, item); // `item`이 `dataObjectRef`로 전달됨
}

// `maxLengthCheck` 함수 정의
function maxLengthCheck(event, dataObjectRef) {
    const object = event.target;

    // 디버깅: 전달된 객체가 무엇인지 콘솔에 출력
    console.log('Received dataObjectRef:', dataObjectRef);

    // `dataObjectRef`가 유효한지 확인
    if (!dataObjectRef) {
        console.debug('Invalid data object reference provided.');
        return;
    }

    // 숫자만 허용하는 경우, 숫자가 아닌 문자 제거
    if (object.dataset.type === 'number') {
        object.value = object.value.replace(/\D/g, '');
    }

    // maxLength 제한이 있는 경우, 입력 길이를 제한
    if (object.maxLength) {
        if (object.value.length > object.maxLength) {
            object.value = object.value.slice(0, object.maxLength);
        }
    }

    // 데이터 모델 업데이트
    dataObjectRef.price = object.value; // 데이터 모델 업데이트
    console.log(`Updated price in data object:`, dataObjectRef.price);
}

function valueCheck(event, dataObjectRef) {
    const object = event.target;

    // 디버깅: 전달된 객체가 무엇인지 콘솔에 출력
    console.log('Received dataObjectRef:', dataObjectRef);

    // `dataObjectRef`가 유효한지 확인
    if (!dataObjectRef) {
        console.debug('Invalid data object reference provided.');
        return;
    }

    // 입력 값이 비어 있는 경우 0으로 설정
    let newValue = object.value.trim();
    if (newValue.length < 1) {
        newValue = '0';
    } else {
        // 숫자 변환: 앞의 불필요한 0을 제거
        newValue = parseInt(newValue, 10).toString();
    }

    // DOM 업데이트
    object.value = newValue;

    // Vue 데이터 모델 업데이트
    dataObjectRef.price = newValue;
    console.log(`Updated price in data object:`, dataObjectRef.price);
}

onMounted(async () => {
	if(globaljs.acc_type !== 'hospital' || globaljs.mb_staff !== 'Worker') {
		step2js.DOMLoaded();
		await getModels();
	}
});

let deleted_id = [];
let changed_id = [];
let beforeValues = [];
let afterValues = [];

const prosthesis_list_add = () => {
	items.value.push({
		cant_del: 0,
		options: '',
		detail: '',
		price: '',
		hide: 0,
	});

	items.value = [...items.value];

	// 230118 jamong
	window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
};

const prosthesis_list_del = (index, itemId) => {
console.debug('prosthesis_list_del().index/itemId', index, itemId);
	const deleted_id_input = document.querySelector('input[name="deleted_id"]');
	if (typeof itemId !== 'undefined') {
		deleted_id.push(itemId);
		deleted_id_input.value = deleted_id.join(',');
		removeFromChangedId(itemId);
	}
	items.value.splice(index, 1);
	beforeData.splice(index, 1);

	// beforeValues와 afterValues에서도 해당 id 값을 삭제
	removeFromBeforeAndAfterValues(itemId);
};

const removeFromChangedId = (id) => {
	// changed_id에서 id를 삭제
	const index = changed_id.indexOf(id);
	if (index !== -1) {
		changed_id.splice(index, 1); // 해당 인덱스에서 1개 요소 삭제

		// 변경된 changed_id 배열을 input에 반영
		const changed_id_input = document.querySelector('input[name="changed_id"]');
		changed_id_input.value = changed_id.join(','); // 배열을 쉼표로 구분해 input에 저장
	}
};

// beforeValues 및 afterValues에서 해당 id를 삭제하는 함수
const removeFromBeforeAndAfterValues = (id) => {
	// beforeValues에서 id 값 삭제
	const beforeIndex = beforeValues.findIndex(item => item.id === id);
	if (beforeIndex !== -1) {
		beforeValues.splice(beforeIndex, 1);
	}

	// afterValues에서 id 값 삭제
	const afterIndex = afterValues.findIndex(item => item.id === id);
	if (afterIndex !== -1) {
		afterValues.splice(afterIndex, 1);
	}

	// 변경된 beforeValues 및 afterValues를 input에 반영
	const beforeInput = document.querySelector('input[name="before_values"]');
	const afterInput = document.querySelector('input[name="after_values"]');

	beforeInput.value = JSON.stringify(beforeValues);
	afterInput.value = JSON.stringify(afterValues);
};

const deepCompareWithId = (obj1, obj2) => {
	// 두 값이 동일하면 true 반환
	if (obj1 === obj2) return true;

	// 둘 중 하나라도 객체가 아니거나 null인 경우 false 반환
	if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
		return false;
	}

	const keys1 = Object.keys(obj1);
	const keys2 = Object.keys(obj2);

	// 공통된 id를 가진 항목만 비교
	if (keys1.includes('id') && keys2.includes('id') && obj1.id === obj2.id) {
		// options 또는 detail이 달라졌는지 확인
		if (obj1.options !== obj2.options || obj1.detail !== obj2.detail) {
console.debug('!== options or detail', obj1.id);

			// changed_id 배열에 중복되지 않도록 체크하고 푸시
			if (!changed_id.includes(obj1.id)) {
				changed_id.push(obj1.id); // 변경된 id 기록
			}
		} else {
			// 값이 원래대로 돌아왔으면 changed_id에서 제거
			removeFromChangedId(obj1.id); // 함수로 중복 코드 제거
		}
	}

	// 재귀적으로 모든 키를 비교
	for (let key of keys1) {
		if (keys2.includes(key) && !deepCompareWithId(obj1[key], obj2[key])) {
			return false;
		}
	}

	return true;
};

const getModels = async () => {
	const params = new URLSearchParams();
	params.append('acc_type', globaljs.acc_type);
	params.append('lab_id', globaljs.mb_boss_id);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/prosthesis`, { params });
console.debug(response.data.result);
		beforeData = JSON.parse(JSON.stringify(response.data.result)); // 240919 이전값 저장
		items.value = response.data.result;
		list_num.value = response.data.result.length;
	} catch (error) {
		console.error('Error getModels:', error);
	}
};

const select_hos = (hos_id) => {
	router.push(`/manage_prosthesis_sub/${hos_id}`);
};

window.select_hos = select_hos;

const showAlertAndFocus = (title, text, inputName, index) => {
	Swal.fire({
		title: title,
		text: text,
		icon: 'error',
		confirmButtonText: '확인',
		allowOutsideClick: false,  // 외부 클릭 방지
		allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
		returnFocus: false,
	}).then((result) => {
		if (result.isConfirmed) {
			setTimeout(() => {
				document.querySelectorAll(`[name="${inputName}[]"]`)[index].focus();
			}, 100);
		}
	});
};

const validateItems = () => {
	for (let i = 0; i < items.value.length; i++) {
		const item = items.value[i];

		if (!item.options || item.options.trim().length < 1) {
			showAlertAndFocus('분류', '분류는 필수 입력 항목입니다.', 'options', i);
			return false;
		}

		if (!item.detail || item.detail.trim().length < 1) {
			showAlertAndFocus('상세', '상세는 필수 입력 항목입니다.', 'detail', i);
			return false;
		}

		// 가격이 숫자 또는 문자열인지에 따라 검증 방법을 선택
		if (item.price === undefined || item.price === null || item.price === '') {
			showAlertAndFocus('단가', '단가는 필수 입력 항목입니다.', 'price', i);
			return false;
		}

		// 가격이 문자열이라면 빈 문자열이나 공백만으로 구성된 문자열이 아닌지 확인
		if (typeof item.price === 'string' && item.price.trim().length < 1) {
			showAlertAndFocus('단가', '단가는 필수 입력 항목입니다.', 'price', i);
			return false;
		}
	}

	return true; // 모든 항목이 유효한 경우 true 반환
};

async function form_prosthesis_update_submit() {
	await withSubmitFlag(async () => {
		if (document.querySelector('input[name="deleted_id"]').value !== '') {
			const is_confirm = await commonjs.confirmSwal('삭제 확인', '치과에서 저장되었던 보철물도 함께 삭제 됩니다.\n그래도 삭제하시겠습니까?', 'nl');
			if (!is_confirm) {
				return false;
			}
		}

		if (!validateItems()) {
			return; // 필드 검증 실패 시 제출 중단
		}

		const params = new URLSearchParams();
		params.append('acc_type', globaljs.acc_type);
		//params.append('mb_level', globaljs.mb_level);
		params.append('lab_id', globaljs.mb_boss_id);

		const form = document.getElementById('form_prosthesis_update');
		form.querySelectorAll('input').forEach(function (input) {
			if (input.type === 'checkbox') {
				if (input.checked) {
					params.append(input.name, input.value);
				}
			} else {
				params.append(input.name, input.value);
			}
		});

		// beforeData와 items.value 비교
		for (let i = 0; i < items.value.length; i++) {
			deepCompareWithId(beforeData[i], items.value[i]);
		}

		if (changed_id.length > 0) {
			console.log("Changes detected in ids:", changed_id);
			const changed_id_input = document.querySelector('input[name="changed_id"]');
			changed_id_input.value = changed_id.join(','); // 변경된 id를 input에 저장
		} else {
			console.log("No changes detected.");
		}

		changed_id.forEach(id => {
			const beforeItem = beforeData.find(item => item.id === id);
			const afterItem = items.value.find(item => item.id === id);

			if (beforeItem && afterItem) {
			// beforeValues 배열에 해당 id가 중복되지 않도록 확인
			const beforeExists = beforeValues.some(item => item.id === beforeItem.id);
			if (!beforeExists) {
				beforeValues.push({
					id: beforeItem.id,
					options: beforeItem.options,
					detail: beforeItem.detail
				});
			}

			// afterValues 배열에 해당 id가 이미 존재하면 최신값으로 갱신
			const afterIndex = afterValues.findIndex(item => item.id === afterItem.id);
				if (afterIndex !== -1) {
					// 기존 항목을 최신값으로 갱신
					afterValues[afterIndex].options = afterItem.options;
					afterValues[afterIndex].detail = afterItem.detail;
				} else {
					// 존재하지 않으면 새로 추가
					afterValues.push({
						id: afterItem.id,
						options: afterItem.options,
						detail: afterItem.detail
					});
				}
			}
		});

		const beforeInput = document.querySelector('input[name="before_values"]');
		const afterInput = document.querySelector('input[name="after_values"]');

		// 수집된 before/after 값을 문자열로 변환하여 input 필드에 저장
		beforeInput.value = JSON.stringify(beforeValues);
		afterInput.value = JSON.stringify(afterValues);

		// URLSearchParams를 객체로 변환
		const object = {};
		params.forEach((value, key) => {
			if (key.endsWith('[]')) {
				const arrayKey = key.slice(0, -2);
				if (!object[arrayKey]) {
					object[arrayKey] = [];
				}
				object[arrayKey].push(value);
			} else {
				object[key] = value;
			}
		});

		// 결과 확인용 로그 출력
		const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
	console.info(jsonString);

		try {
			const response = await axios.post(`${SERVER_URL}/api/app/prosthesis`, params);
	console.debug(response.data.result);

			toast.fire({
				icon: "success",
				title: "보철물을 업데이트했습니다."
			});

			getModels();

		} catch (error) {
			console.error(error?.response?.data);
			commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
		}
	});
}
</script>
<style>
#form_prosthesis_update table .cols5 label {
	display: block;
	margin: 0;
}

#form_prosthesis_update table .cols6 label {
	display: block;
	margin: 0;
}

.readonly {
	background: #eee;
}

.align_right {
	text-align: right;
	margin-bottom: 20px;
	width: 100%;
}

.setting_add_btn {
	background: #ff0000;
}

.setting_add_btn:hover {
	background: #dd0000;
}

/* 240426 추가[즐겨찾기 숨김] */
#form_prosthesis_update table .cols6 {
	display: none;
}

/* 240426 추가 끝*/
</style>